// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    ProviderType,
    ProviderTypeFromJSON,
    ProviderTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderProvider
 */
export interface ProviderProvider {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    id?: string;
    /**
     * Organization name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    organization?: string;
    /**
     * Individual first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    first?: string;
    /**
     * Individual middle name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    middle?: string;
    /**
     * Individual last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    last?: string;
    /**
     * Individual suffix
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    suffix?: string;
    /**
     * Provider nickname
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    nickname?: string;
    /**
     * The addresses
     * OpenAPI data type: {array}
     * @type {Array<Address>}
     * @memberof ProviderProvider
     */
    addresses?: Array<Address>;
    /**
     * National Provider Identification
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    npi?: string;
    /**
     * Organization tax number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    ein?: string;
    /**
     * Individual tax number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    ssn?: string;
    /**
     * Medicare number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    ptan?: string;
    /**
     * License or certificate number (NF3)
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    license?: string;
    /**
     * WCB Rating code (NF3)
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    wcb?: string;
    /**
     * UPIN
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    upin?: string;
    /**
     * The commercial number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    commercialNumber?: string;
    /**
     * The location number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    locationNumber?: string;
    /**
     * Other number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    other?: string;
    /**
     * Taxonomy qualifier code (usually ZZ)
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    taxonomyQualifier?: string;
    /**
     * Taxonomy code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    taxonomyCode?: string;
    /**
     * Provider is an employee (NF3)
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProvider
     */
    employee?: boolean;
    /**
     * Website URL
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    websiteUrl?: string;
    /**
     * Provider is a contractor (NF3)
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProvider
     */
    contractor?: boolean;
    /**
     * Email address of the provider
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    email?: string;
    /**
     * Phone number in E.164 format
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    phone?: string;
    /**
     * Fax number in E.164 format
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProvider
     */
    fax?: string;
    /**
     * Is provider marked as halted
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProvider
     */
    halt?: boolean;
    /**
     * 
     * OpenAPI data type: {ProviderType}
     * @type {ProviderType}
     * @memberof ProviderProvider
     */
    type?: ProviderType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProvider
     */
    created?: string;
}

export function ProviderProviderFromJSON(json: any): ProviderProvider {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'organization': !exists(json, 'organization') ? undefined : json['organization'],
            'first': !exists(json, 'first') ? undefined : json['first'],
            'middle': !exists(json, 'middle') ? undefined : json['middle'],
            'last': !exists(json, 'last') ? undefined : json['last'],
            'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
            'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
            'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] as Array<any>).map(AddressFromJSON),
            'npi': !exists(json, 'npi') ? undefined : json['npi'],
            'ein': !exists(json, 'ein') ? undefined : json['ein'],
            'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
            'ptan': !exists(json, 'ptan') ? undefined : json['ptan'],
            'license': !exists(json, 'license') ? undefined : json['license'],
            'wcb': !exists(json, 'wcb') ? undefined : json['wcb'],
            'upin': !exists(json, 'upin') ? undefined : json['upin'],
            'commercialNumber': !exists(json, 'commercialNumber') ? undefined : json['commercialNumber'],
            'locationNumber': !exists(json, 'locationNumber') ? undefined : json['locationNumber'],
            'other': !exists(json, 'other') ? undefined : json['other'],
            'taxonomyQualifier': !exists(json, 'taxonomyQualifier') ? undefined : json['taxonomyQualifier'],
            'taxonomyCode': !exists(json, 'taxonomyCode') ? undefined : json['taxonomyCode'],
            'employee': !exists(json, 'employee') ? undefined : json['employee'],
            'websiteUrl': !exists(json, 'websiteUrl') ? undefined : json['websiteUrl'],
            'contractor': !exists(json, 'contractor') ? undefined : json['contractor'],
            'email': !exists(json, 'email') ? undefined : json['email'],
            'phone': !exists(json, 'phone') ? undefined : json['phone'],
            'fax': !exists(json, 'fax') ? undefined : json['fax'],
            'halt': !exists(json, 'halt') ? undefined : json['halt'],
            'type': !exists(json, 'type') ? undefined : ProviderTypeFromJSON(json['type']),
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function ProviderProviderToForm(value?: ProviderProvider): any {
    let jsonVal = ProviderProviderToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderProviderToJSON(value?: ProviderProvider): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'organization': cleanupBlankValuesForBackend(value.organization),
            'first': cleanupBlankValuesForBackend(value.first),
            'middle': cleanupBlankValuesForBackend(value.middle),
            'last': cleanupBlankValuesForBackend(value.last),
            'suffix': cleanupBlankValuesForBackend(value.suffix),
            'nickname': cleanupBlankValuesForBackend(value.nickname),
            'addresses': (value.addresses === undefined || value.addresses === null) ? undefined : (value.addresses as Array<any>).map(AddressToJSON),
            'npi': cleanupBlankValuesForBackend(value.npi),
            'ein': cleanupBlankValuesForBackend(value.ein),
            'ssn': cleanupBlankValuesForBackend(value.ssn),
            'ptan': cleanupBlankValuesForBackend(value.ptan),
            'license': cleanupBlankValuesForBackend(value.license),
            'wcb': cleanupBlankValuesForBackend(value.wcb),
            'upin': cleanupBlankValuesForBackend(value.upin),
            'commercialNumber': cleanupBlankValuesForBackend(value.commercialNumber),
            'locationNumber': cleanupBlankValuesForBackend(value.locationNumber),
            'other': cleanupBlankValuesForBackend(value.other),
            'taxonomyQualifier': cleanupBlankValuesForBackend(value.taxonomyQualifier),
            'taxonomyCode': cleanupBlankValuesForBackend(value.taxonomyCode),
            'employee': cleanupBlankValuesForBackend(value.employee),
            'websiteUrl': cleanupBlankValuesForBackend(value.websiteUrl),
            'contractor': cleanupBlankValuesForBackend(value.contractor),
            'email': cleanupBlankValuesForBackend(value.email),
            'phone': cleanupBlankValuesForBackend(value.phone),
            'fax': cleanupBlankValuesForBackend(value.fax),
            'halt': cleanupBlankValuesForBackend(value.halt),
            'type': ProviderTypeToJSON(value.type),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


